import { CommonMsgNodeProps, ImageWithTextMessageType } from '@/types/message'
import styles from './index.module.scss'
import { Image } from 'antd'
import fallBackPng from '@/assets/images/loading.gif'

interface ImageWithTextMsgProps extends CommonMsgNodeProps {
  node: ImageWithTextMessageType
  typing?: boolean
}

const ImageWithTextMsg = (props: ImageWithTextMsgProps) => {
  const { node } = props
  const { value, display = 'block' } = node

  const isBlockLayout = display === 'block'
  const style = {
    display: isBlockLayout ? 'flex' : 'inline'
  }

  const images = value?.images || []

  const placeholder = <Image preview={false} src={fallBackPng} />

  if (images?.length === 0 && !value?.text) {
    return null
  }

  return (
    <div className={styles.container} style={style}>
      {images?.length > 0 && (
        <div className={styles.imgBox}>
          {images?.map((img, index) => (
            <Image
              placeholder={placeholder}
              fallback={fallBackPng}
              key={index}
              className={styles.img}
              src={img}
              alt="image"
              // style={{
              // objectFit: 'cover'
              // }}
              // height={800}
            />
          ))}
        </div>
      )}
      {value?.text && (
        <div className={styles.rightTextBox}>
          <span className={styles.rightText}>{value?.text}</span>
        </div>
      )}
    </div>
  )
}

export default ImageWithTextMsg
